const ReportsConfig = {
  collection: "reports",
  fields: ["id", "type.id", "report_generation_status", "generated_report"],

  adapter: class Report {
    constructor(report) {
      Object.assign(this, report);
    }
    map(collections, maps) {
      this.type = maps.report_types[this.type?.id];
    }
  }
};

export default ReportsConfig;
